<template>
	<div class="bottom-player-bar flex-space-between--center">
		<div class="left-side flex-1 flex-start--center">
			<div class="flex-centerize" @click="$emit('displayChapterList')"><ShowPlaylistSvg class="light-hover-effect" /></div>
			<DotSelector :dotArray="dotArray" :currentDotIndex="currentChapterIndex" @dotClicked="(v) => $emit('dotClicked', v)" />
		</div>
		<div class="player-controller flex-1 flex-centerize flex-column">
			<PlayerController
				:isHidden="isHidden"
				:isPlaying="isPlaying"
				:showHideButton="showHideButton"
				@setIsHidden="(v) => $emit('setIsHidden', v)"
				@setIsPlaying="setIsPlaying"
			/>
			<div class="font-size-md">{{ tutorialSteps[currentChapterIndex].description }}</div>
		</div>
		<div class="right-side flex-1 flex-end--center">
			<div @click="$emit('restartVideo')">
				<AppTooltip text="Restart chapter" class="flex-centerize">
					<RestartSvg class="light-hover-effect" />
				</AppTooltip>
			</div>
			<v-menu v-model="isMenuOpen" dense :nudge-top="50" :nudge-left="40">
				<template v-slot:activator="{ on, attrs }">
					<div id="bottom_player_bar_menu_id"></div>
					<div class="display-flex" v-bind="attrs" v-on="on"><ThreeDotMenuSvg class="light-hover-effect" /></div>
				</template>
				<v-list dense>
					<v-list-item dense @click="$emit('onClose')"> Close </v-list-item>
				</v-list>
			</v-menu>
		</div>
	</div>
</template>

<script>
import PlayerController from './PlayerController';
import DotSelector from './DotSelector';

import ShowPlaylistSvg from './assets/ShowPlaylistSvg';
import RestartSvg from './assets/RestartSvg';
import ThreeDotMenuSvg from './assets/ThreeDotMenuSvg';

export default {
	name: 'BottomPlayerBar',
	components: {
		PlayerController,
		ShowPlaylistSvg,
		RestartSvg,
		ThreeDotMenuSvg,
		DotSelector,
	},
	props: {
		isPlaying: { type: Boolean },
		isHidden: { type: Boolean },
		showHideButton: { type: Boolean },
		currentChapterIndex: { type: Number },
		dotArray: { type: Array, default: () => [] },
		tutorialSteps: { type: Array, default: () => [] },
	},
	computed: {},
	methods: {
		setIsPlaying(v) {
			this.$emit('setIsPlaying', v);
			this.$emit('setIsHidden', !v);
		},
	},
	watch: {},
	mounted() {},
	data() {
		return { isMenuOpen: false };
	},
};
</script>

<style lang="scss" scoped>
.bottom-player-bar {
	position: absolute;
	bottom: 0;
	left: 0;
	height: $bottom-player-bar-height;
	width: 100vw;
	padding: 0 20px;
	background: #5b5be6;
	z-index: 999;

	.player-controller {
		transform: translate(0, calc(40px - #{$bottom-player-bar-height}));
		color: white;

		&:hover {
			cursor: pointer;
			filter: brightness(95%);
			transition: 0.3s;
		}
		&:not(:hover) {
			transition: 0.3s;
		}
	}

	.left-side,
	.right-side {
		> *:not(:last-child) {
			margin-right: 12px;
		}
	}

	.player-btn {
		display: flex;

		&:hover {
			filter: brightness(105%);
			cursor: pointer;
		}
	}
}
</style>
